import React from 'react';
import PropTypes from 'prop-types';
import { requestHelpers } from "../../../../../../helpers/";


export class CvAdvert extends React.Component {
    constructor( props ){
        super( props );
        this.state = { cvInterestSent : false, disableCvIntegrateButton : false };
    }

    cvInterestClicked(){
        this.setState({ disableCvIntegrateButton : true });
        requestHelpers
            .authenticatedPostRequest( '/communications/enquire-writing-services', { person_id : window.localStorage.getItem( 'person_id' ), page : 'CvAdvert' } )
            .then( res => this.setState({ cvInterestSent : true }) )
            .catch( err => this.setState({ disableCvIntegrateButton : false }, () => console.error( 'err : ', err ) ) );
    };

    render(){
        return (
            <article className="cv-advert__container">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="cv-advert__header">
                            <img className="cv-advert__icon" src="/images/icon_membership-benefits-collateral.png"
                                    alt="cv-icon"/>
                            <h5 className="h5 emphasis-color">Is your CV strong enough?</h5>
                        </div>
                    </div>
                    <div className="col-xs-12">
                        <p className="p-tag">Making the right impression with your CV is essential when applying for any
                            role, even more so when the position is at a senior or management level.</p>
                        { this.state.cvInterestSent && <p className="body-copy lead-message">Thank you for your enquiry. Someone from our CV services team will be in touch.</p>}
                        <a className={ `theme-button${ this.state.disableCvIntegrateButton ? ' disabled' : '' }` } href="/writing-services">
                            Find out more
                        </a>
                    </div>
                </div>
            </article>
        );
    }
}

CvAdvert.propTypes = {
    job: PropTypes.object,
    openInNewWindow: PropTypes.func,
    registerInterest: PropTypes.func,
}


// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/CvAdvert.js